import type { IBettingAPI } from 'types';
import BettingAPI from '../root/BettingAPI';

let bettingAPI: IBettingAPI | null = null;

export default function getBettingAPI(): IBettingAPI {
    if (bettingAPI) return bettingAPI;

    bettingAPI = new BettingAPI();

    return bettingAPI;
}
